import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from './cn';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-succession-primary text-white',
        secondary: 'border-transparent bg-succession-bg-secondary text-succession-text-primary',
        destructive: 'border-transparent bg-red-100 text-red-800',
        outline: 'text-succession-text-primary border-succession-border',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

function Badge({ className, variant, ...props }) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
